<template>
  <div
    class="px-4"
    style="margin-top: 100px"
  >
    <v-card class="py-4 login-card">
      <v-layout
        row
        wrap
        style="align-items: center"
      >
        <v-btn
          flat
          icon
          color="primary"
          @click="toggleCampaignDialog"
        >
          <v-icon>
            $vuetify.icons.arrowLeftIcon
          </v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="primary"
          style="text-transform: none"
          @click="$router.push(`/login`)"
        >
          Voltar
        </v-btn>
      </v-layout>
      <v-form
        v-model="valid"
        @submit="forgotPassword"
      >
        <div class="text-xs-center">
          <v-snackbar
            v-model="snackbar"
            :class="color === 'white' ? snackBar-error : snackbar"
            :color="color"
            :top="true"
            :multi-line="true"
          >
            <v-icon
              v-show="color === 'white'"
              small
              color="red"
              style="margin-right: 15px"
            >
              fas fa-exclamation-circle
            </v-icon>
            {{ text }}
            <v-btn
              :class="color === 'white' ? snackBar-btn-error : snackbar-btn"
              width="675px"
              outline
              @click="snackbar = false"
            >
              Ok
            </v-btn>
          </v-snackbar>

          <v-layout
            pa-2
            class="lightbox white--text"
          >
            <v-flex>
              <div class="cabecalho animated fadeIn delay-1s d-flex align-center justify-center">
                <v-img
                  :src="require('../assets/logoBolden.png')"
                  contain
                  max-width="188px"
                />
              </div>

              <v-layout
                align-center
                justify-center
                row
              >
                <v-flex
                  xs10
                  lg3
                  class="px-4 margin-to-top animated fadeInUp delay-1s"
                >
                  <v-text-field
                    v-model="email"
                    label="Email"
                    color="primary"
                    prepend-icon="$vuetify.icons.userIcon"
                    clearable
                    :rules="[rules.required]"
                  />
                </v-flex>
              </v-layout>

              <v-flex class="mt-3">
                <v-btn
                  type="submit"
                  color="primary"
                  class="animated fadeInLeft delay-1s forgot-password-btn"
                >
                  <span>Continuar</span>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-layout>
        </div>
      </v-form>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      valid: null,
      show: false,
      snackbar: false,
      text: '',
      color: '',
      email: null,
      password: '',
      repassword: '',
      rules: {
        required: (value) => !!value || 'Campo Obrigatorio',
        min: (v) => (v && v.length >= 8) || 'Minimo de 8 caracteres',
        emailMatch: () => ('The email and password you entered don\'t match'),
      },
    };
  },
  methods: {
    forgotPassword(e) {
      e.preventDefault();
      if (this.valid) {
        this.$auth.forgotPassword(this.email, (err, resp) => {
          if (err) {
            this.color = 'white';
            this.text = 'Ocorreu um erro, por favor tente novamente mais tarde.';
            this.snackbar = true;
            console.log('Error', err);
          } else {
            this.color = '#FFADDE';
            this.text = 'Um e-mail foi enviado para sua caixa de mensagem.';
            this.snackbar = true;
          }
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .snackBar-error {
    color: red !important;
    caret-color: red !important;
    text-align: left !important;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.1) !important;
}
::v-deep .snackBar {
    color: 'primary' !important;
    caret-color: 'primary' !important;
    text-align: left !important;
    box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.1) !important;
}
::v-deep .v-input .v-label {
  font-family: 'Neue-Metana' !important;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}
.snackbar-btn {
    border-radius: 7.08982px;
    color: 'primary' !important;
    caret-color: 'primary' !important;
    min-width: 83px !important;
}
.snackbar-btn-error {
    border-radius: 7.08982px;
    color: red !important;
    caret-color: red !important;
    min-width: 83px !important;
}
</style>

<style scoped>
a {
  color: white;
}
.cabecalho {
  font-size: 50px;
  margin-top: 50px;
  letter-spacing: 2px;
}
.forgot-password-btn{
  border-radius: 7.08982px;
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: normal;
  font-size: 8.68576px;
}
.icon-cabecalho {
  font-size: 30px !important;
  padding-right: 4px;
  padding-bottom: 10px;
}
.margin-to-top {
  margin-top: 80px;
}
.margin-to-bottom {
    margin-top: 200px;
}
</style>
